import React from "react";
import { withRouter } from "react-router-dom";
import Presenter from "./Presenter";

import { useQuery } from "react-apollo-hooks";
import { STORE_DELIVERY_ORDER_DETAIL_QUERY } from "../Queries";

export default withRouter(({ history, match, location }) => {
  const id = match.params.id;
  const baseUrl = `/delivery/deliveryOrders/${id}`;

  const { data, loading, error } = useQuery(STORE_DELIVERY_ORDER_DETAIL_QUERY, {
    fetchPolicy: "network-only",
    variables: { id },
  });

  if (loading) {
    return <></>;
  }
  if (error) {
    return <>{error.message}</>;
  }

  return (
    <Presenter
      history={history}
      match={match}
      location={location}
      loading={loading}
      data={data}
      baseUrl={baseUrl}
    />
  );
});
